import en from './en';
import es from './es';
import pt from './pt';

const translations = {
  en,
  es,
  pt
};

export default translations;
